/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reference: NonNullable<unknown> }} Bell_Object_InboundInputs */

const en_bell_object_inbound = /** @type {(inputs: Bell_Object_InboundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inbound ${i?.reference}`)
};

/**
* | output |
* | --- |
* | "Inbound {reference}" |
*
* @param {Bell_Object_InboundInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_object_inbound = /** @type {((inputs: Bell_Object_InboundInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Object_InboundInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_object_inbound(inputs)
});